export function uppercaseFR(str: string) {
	const keyword = "firmenradl";
	const regex = new RegExp(`${keyword}-`, "gi");

	return str.replace(regex, `${keyword.toUpperCase()} `);
}
